import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ChipValueType, ChipsDataType, FreeChipValueType, CasinoChipValueType } from './types';

const initialState: {
  chipsData: ChipsDataType;
  chips: ChipValueType[];
  chipsReady: boolean;
  selectedChip: ChipValueType | null;
  isClipChipStackOpened: boolean;
  isRevolverChipStackOpened: boolean;
} = {
  chipsData: {
    casinoChips: [],
    freeChips: [],
  },
  chips: [],
  chipsReady: false,
  selectedChip: null,
  isClipChipStackOpened: false,
  isRevolverChipStackOpened: false,
};

export const chipSlice = createSlice({
  name: 'chips',
  initialState,
  reducers: {
    setChips: (state, action: PayloadAction<ChipValueType[]>) => {
      state.chips = action.payload;
      state.chipsReady = true;
    },
    setCasinoChips: (state, action: PayloadAction<CasinoChipValueType[]>) => {
      state.chipsData.casinoChips = action.payload;
    },
    setFreeChips: (state, action: PayloadAction<FreeChipValueType[]>) => {
      state.chipsData.freeChips = action.payload;
    },
    updateFreeChipsState: (
      state,
      action: PayloadAction<{ disabled: boolean; count?: number; disabledReason: string }>
    ) => {
      state.chipsData.freeChips = state.chipsData.freeChips.map((chip) => {
        return { ...chip, ...action.payload };
      });
    },
    updateCasinoChipsState: (state, action: PayloadAction<{ disabled: boolean; disabledReason: string }>) => {
      const { disabled, disabledReason } = action.payload;
      state.chipsData.casinoChips = state.chipsData.casinoChips.map((chip) => {
        return { ...chip, disabled, disabledReason };
      });
    },
    setSelectedChip: (state, action: PayloadAction<ChipValueType>) => {
      state.selectedChip = action.payload;
    },
    // settingSyncMiddleware listens for this action to save selected chip in playerConfig on server
    setAndSyncSelectedChip: (state, action: PayloadAction<ChipValueType>) => {
      state.selectedChip = action.payload;
    },
    setClipChipStackOpened: (state, action: PayloadAction<boolean>) => {
      state.isClipChipStackOpened = action.payload;
    },
    setRevolverChipStackOpened: (state, action: PayloadAction<boolean>) => {
      state.isRevolverChipStackOpened = action.payload;
    },
  },
});

export const chipActions = chipSlice.actions;
